import { useEffect, useState } from "react";
import httpService from "../services/httpService";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import OnboardingModal from "../components/ListenerComponents/OnboardingModal";
import OnboardingModalInvite from "../components/ListenerComponents/OnboardingModalInvite";
import ListenerPublicClubs from "../components/ListenerComponents/ListenerPublicClubs";
import ListenerInvites from "../components/ListenerComponents/ListenerInvites";
import ListenerPodcasters from "../components/ListenerComponents/ListenerPodcasters";
import ListenerJoinWithCode from "../components/ListenerComponents/ListenerJoinWithCode";
import { FaCompass, FaEnvelope, FaMicrophone, FaKey } from "react-icons/fa";
import "../styles/dashbaords.scss";
import "../styles/ClubsToJoin.scss";
import PageHero from "../components/PageHero";

const ListenerClubsToJoin = () => {
    const [showOnboardingModal, setShowOnboardingModal] = useState(false);
    const [showInviteOnboardingModal, setShowInviteOnboardingModal] = useState(false);
    const [firstPendingInvite, setFirstPendingInvite] = useState(null);
    const [activeTab, setActiveTab] = useState('public-clubs');

    useEffect(() => {
        httpService.get("/dash/listener-dashboard")
            .then((res) => {
                if (res.data.is_first_login) {
                    httpService.get("/dash/get-invites", { params: { status: 'pending', pageSize: 1 } })
                        .then((inviteRes) => {
                            if (inviteRes.data.data && inviteRes.data.data.length > 0) {
                                setFirstPendingInvite(inviteRes.data.data[0]);
                                setShowInviteOnboardingModal(true);
                            } else {
                                setShowOnboardingModal(true);
                            }
                        })
                        .catch(() => setShowOnboardingModal(true));
                }
            })
            .catch((err) => console.error('Error loading dashboard data:', err));
    }, []);

    return (
        <div id="ListenerClubsToJoin-component">

            {/* ── Hero ─────────────────────────────── */}
            <PageHero>
                <h1 className="page-hero__title">
                    <FaCompass className="me-3" style={{ opacity: 0.75 }} />
                    Discover &amp; Join
                </h1>
                <p className="page-hero__sub">
                    Find podcast clubs to grow your skills, accept private invites, or explore authors.
                </p>
            </PageHero>

            {/* ── Tabs ─────────────────────────────── */}
            <div className="container-lg py-4 px-3 px-lg-4">
                <Tabs
                    id="listener-clubs-tabs"
                    activeKey={activeTab}
                    onSelect={(k) => setActiveTab(k)}
                    className="mb-4"
                >
                    <Tab
                        eventKey="public-clubs"
                        title={<span><FaCompass className="me-1" />Public Clubs</span>}
                    >
                        <ListenerPublicClubs />
                    </Tab>

                    <Tab
                        eventKey="invites"
                        title={<span><FaEnvelope className="me-1" />Invites</span>}
                    >
                        <ListenerInvites />
                    </Tab>

                    <Tab
                        eventKey="authors"
                        title={<span><FaMicrophone className="me-1" />Authors</span>}
                    >
                        <ListenerPodcasters />
                    </Tab>

                    <Tab
                        eventKey="join-with-code"
                        title={<span><FaKey className="me-1" />Join with code</span>}
                    >
                        <ListenerJoinWithCode />
                    </Tab>
                </Tabs>
            </div>

            <OnboardingModal
                show={showOnboardingModal}
                onHide={() => setShowOnboardingModal(false)}
            />
            <OnboardingModalInvite
                show={showInviteOnboardingModal}
                onHide={() => setShowInviteOnboardingModal(false)}
                invite={firstPendingInvite}
            />
        </div>
    );
};

export default ListenerClubsToJoin;
